import { render, staticRenderFns } from "./5dcb73bb-e1e1-49d2-99f4-054211da1a25.vue?vue&type=template&id=22f2f09f&scoped=true"
import script from "./5dcb73bb-e1e1-49d2-99f4-054211da1a25.vue?vue&type=script&lang=ts"
export * from "./5dcb73bb-e1e1-49d2-99f4-054211da1a25.vue?vue&type=script&lang=ts"
import style0 from "./5dcb73bb-e1e1-49d2-99f4-054211da1a25.vue?vue&type=style&index=0&id=22f2f09f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f2f09f",
  null
  
)

export default component.exports